import { Box, Button } from "@material-ui/core"
import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { usePageTracking } from "../../../hooks"
import { AnalyticsPageCategory, AnalyticsPageType } from "../../../models"

import type { Chapter, LinkChapter } from "../../../redux"
import { history } from "../../../redux"
import { Header2, Header3 } from "../../atoms"
import { PageContainer } from "../../molecules"
import { IndexViewer, RecentMaps, SearchBar, SearchBarProvider } from "../../organisms"

import "./start-page.styles.scss"

export function StartPage(): ReactElement {
  usePageTracking(AnalyticsPageCategory.Home, AnalyticsPageType.Content)
  const { t } = useTranslation("startPage")

  function navigateToChapter(chapter: Chapter | LinkChapter): void {
    if ("url" in chapter) {
      window.open(chapter.url)
    } else {
      history.push(`/chapter/${chapter.id}`)
    }
  }

  return (
    <>
      <PageContainer id="start-page">
        <SearchBarProvider>
          <SearchBar />
        </SearchBarProvider>
        <Box id="start-page-index">
          <Header3>{t("findCardIndex")}</Header3>
          <IndexViewer onChapterClicked={navigateToChapter} hideHeaders hideBottomSection />
          <Button className="to-index-button" variant="text" color="primary" onClick={() => history.push("/content")}>
            {t("goToIndex")}
          </Button>
        </Box>
      </PageContainer>
      <Box className="recent-maps">
        <Box id="start-page-recent-maps" className="recent-maps-container">
          <Header2>{t("newMaps")}</Header2>
          <RecentMaps count={4} />
        </Box>
      </Box>
    </>
  )
}
